module.exports = __webpack_public_path__ + "static/img/侧边栏1.68f96eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/侧边栏1.png
// module id = lL/Q
// module chunks = 0